import StyledButton from "@components/buttons/StyledButton"
import { ArrowLeftIcon } from "@radix-ui/react-icons"
import { useSyncStatesWithSocket } from "@utils/useSyncStatesWithSockets"
import gsap from "gsap"
import { useEffect, useRef } from "react"
import styled from "styled-components"

type Props = {
  isVisible: boolean
}

const OverviewScreen = (props: Props) => {
  const isVisible = props.isVisible

  const { syncStatesWithSocket: syncState } = useSyncStatesWithSocket()

  const overviewRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (overviewRef.current) {
      if (props.isVisible) {
        gsap.to(overviewRef.current, {
          autoAlpha: 1,
          duration: 0.6,
          ease: "power3.inOut",
        })
      } else {
        gsap.to(overviewRef.current, {
          autoAlpha: 0,
          duration: 0.6,
          ease: "power3.inOut",
        })
      }
    }
  }, [props.isVisible])

  return (
    <OverviewWrapper ref={overviewRef} visible={isVisible}>
      <div
        className="back"
        onClick={() => {
          syncState({ overviewVisible: false })
        }}
      >
        <ArrowLeftIcon height={20} width={20} color="#000" />
        <StyledButton
          border={false}
          color="#000"
          style={{
            margin: 0,
            padding: 0,
          }}
        >
          Back
        </StyledButton>
      </div>
      <img src="assets/images/overview.png" />
    </OverviewWrapper>
  )
}

export default OverviewScreen

const OverviewWrapper = styled.div<{ visible: boolean }>`
  width: 100%;
  height: 100%;
  display: grid;
  background-color: white;
  position: absolute;
  z-index: 100;
  visibility: ${(props) => (props.visible ? "visible" : "hidden")};
  opacity: ${(props) => (props.visible ? 1 : 0)};
  overflow: hidden;
  place-items: center;

  img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .back {
    position: absolute;
    display: flex;
    align-items: center;
    top: 3em;
    left: 30px;
    gap: 1em;
    padding: 1em 1em 1em 0;
    z-index: 20;
  }
`
